import { atom } from '@podium/store';

import { AtomChannels, AtomTopics } from '.';

export const $skyscrapersPositionAtom = atom<'sticky' | 'static'>(
  AtomChannels.Podlet,
  AtomTopics.Cycle,
  'sticky'
);
